import { baseApi, standardQueryTableRequest } from "api/baseApi";
import { IQueryParams } from "api/requestModels";
import { IEmployeeModel } from "./employeeModels";

export const baseEmployeesRoute = "/api/users";

const employeesApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getEmployees: builder.query<IEmployeeModel, IQueryParams>({
            query: standardQueryTableRequest<IEmployeeModel>(`${baseEmployeesRoute}/get-all`),
        }),
    }),
    overrideExisting: false,
});

export const { useGetEmployeesQuery, endpoints } = employeesApi;
